<template>
  <div>
    <el-form label-width="60px" :model="searchForm">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="用户名">
            <el-input
              class="cus_width"
              v-model="searchForm.username"
              placeholder="用户名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button @click="getUserList" type="success">搜索</el-button>
            <el-button
              type="primary"
              @click="addUpdateUserButton(null)"
              v-if="hasAuth('sys:user:save')"
            >
              新增
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column align="center" fixed="left" type="selection" width="55"></el-table-column> -->

      <el-table-column label="头像" align="center" width="100">
        <template slot-scope="scope">
          <el-avatar :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>

      <el-table-column
        prop="username"
        align="center"
        label="用户名"
        width="120"
      ></el-table-column>
      <el-table-column prop="code" align="center" width="200" label="角色名称">
        <template slot-scope="scope">
          <el-tag
            size="small"
            type="info"
            v-for="item in scope.row.sysRoles"
            :key="item.id"
          >
            {{ item.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="200"
        prop="phone"
        label="手机号"
      ></el-table-column>
      <el-table-column
        prop="email"
        align="center"
        label="邮箱"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="created"
        align="center"
        width="200"
        label="创建时间"
      ></el-table-column>
      <el-table-column
        prop="icon"
        align="center"
        min-width="400px"
        label="操作"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.sysRoles.length > 0">
            <el-button
              type="success"
              plain
              @click="roleHandle(scope.row.id)"
              v-if="scope.row.sysRoles[0].name != '门店管理员'"
            >
              分配角色
            </el-button>

            <el-button
              type="warning"
              plain
              @click="repassHandle(scope.row.id, scope.row.username)"
              v-if="scope.row.sysRoles[0].name != '门店管理员'"
            >
              重置密码
            </el-button>
            <el-button
              type="primary"
              v-if="scope.row.sysRoles[0].name != '门店管理员'"
              plain
              @click="addUpdateUserButton(scope.row.id)"
            >
              编辑
            </el-button>
            <template v-if="scope.row.sysRoles[0].name != '门店管理员'">
              <el-popconfirm
                title="这是一段内容确定删除吗？"
                @confirm="delHandle(scope.row.id)"
              >
                <el-button type="danger" plain slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </div>
          <div v-else>
            <el-button type="success" plain @click="roleHandle(scope.row.id)">
              分配角色
            </el-button>

            <el-button
              type="warning"
              plain
              @click="repassHandle(scope.row.id, scope.row.username)"
            >
              重置密码
            </el-button>
            <el-button
              type="primary"
              plain
              @click="addUpdateUserButton(scope.row.id)"
            >
              编辑
            </el-button>
            <template>
              <el-popconfirm
                title="这是一段内容确定删除吗？"
                @confirm="delHandle(scope.row.id)"
              >
                <el-button type="danger" plain slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    ></el-pagination>

    <AddUpdateUser
      ref="addUpdateUser"
      v-if="addUpdateUservisible"
      @refreshDataList="getUserList"
    ></AddUpdateUser>
    <AssignRoles
      ref="adssignRoles"
      v-if="assignRolesvisible"
      @refreshDataList="getUserList"
    ></AssignRoles>
  </div>
</template>
<script>
import AddUpdateUser from "./AddUpdateUser";
import AssignRoles from "./AssignRoles";
export default {
  name: "user",
  components: {
    AddUpdateUser,
    AssignRoles,
  },
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,
      tableData: [],
      total: 0,
      size: 10,
      current: 1,
      selectUservisible: false,
      addUpdateUservisible: false,
      assignRolesvisible: false,
    };
  },
  created() {
    this.getUserList();
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getUserList();
    },
    getUserList() {
      this.$axios
        .get("/admin/user/list", {
          params: {
            username: this.searchForm.username,
            pageNo: this.current,
            pageSize: this.size,
          },
        })
        .then((res) => {
          res.data.records.forEach((i) => {
            i.sysRoles.forEach((j) => {
              if (j.id == 4) {
                i.shanghu = j.id;
              } else {
                i.shanghu = null;
              }
            });
          });

          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
        });
    },
    delManager(id) {
      this.$axios
        .post("/admin/manager/delManager", {
          userId: id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.getUserList();
            },
          });
        });
    },
    delMerchants(id) {
      this.$axios
        .post("/admin/manager/delMerchants", {
          userId: id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.getUserList();
            },
          });
        });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }


      this.$axios.post("/admin/user/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.getUserList();
          },
        });
      });
    },
    repassHandle(id, username) {
      this.$confirm("将重置用户【" + username + "】的密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios.post("/admin/user/repass", id).then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
      });
    },
    addUpdateUserButton(id) {
      this.addUpdateUservisible = true;
      this.$nextTick(() => {
        this.$refs.addUpdateUser.init(id);
      });
    },
    roleHandle(id) {
      this.assignRolesvisible = true;
      this.$nextTick(() => {
        this.$refs.adssignRoles.init(id);
      });
    },
    statusManager(e) {
      this.selectUservisible = true;
      this.$nextTick(() => {
        this.$refs.selectUser.init(e);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
